import { mount } from 'svelte';
import TitleSearch from './TitleSearch.svelte';

const el = document.getElementById('title-search');
if (el) {
  const raw = el.getAttribute('data-props');
  const data = raw ? JSON.parse(raw) : { selected: [], keyword: '' };

  // mount(), not hydrate(): the server renders a working plain keyword input here as the no-JS
  // fallback, and this component replaces it outright rather than claiming to match its markup.
  el.innerHTML = '';

  mount(TitleSearch, {
    target: el,
    props: {
      selected: data.selected || [],
      keyword: data.keyword || '',
      label: data.label || 'search',
      placeholder: data.placeholder || 'title or keyword',
      requireSelection: data.requireSelection === true
    }
  });
} else {
  console.error('TitleSearch element not found');
}
